import i18n from '@i18next/i18n';
import ShapeConvert from '@src/slide/domain/ui-model/element-modeles/convert/shapeConvert';
import { convertBoolToNumber, setUiValueToSdkIfNotNil } from '../../../../convert/chartConvert';
import { ChartType, EGrouping, TrendlineType } from '../../../../Interface/chart-v2/chart-model.interface';

export const trendLineNameMap: Record<TrendlineType, string> = {
    [TrendlineType.LINEAR]: i18n.t('线性'),
    [TrendlineType.EXPONENTIAL]: i18n.t('指数'),
    [TrendlineType.LOG]: i18n.t('对数'),
    [TrendlineType.POWER]: i18n.t('乘幂'),
    [TrendlineType.POLYNOMIAL]: i18n.t('多项式'),
    [TrendlineType.MOVING_AVG]: i18n.t('移动平均'),
};

export class Trendline {
    public static convertDataUiToSdk(uiData) {
        const sdkData: any = {};

        sdkData.period = uiData.period;
        sdkData.order = uiData.order;
        sdkData.forward = uiData.forward;
        sdkData.backward = uiData.backward;
        sdkData.name = uiData.name;
        setUiValueToSdkIfNotNil(sdkData, 'dispEq', convertBoolToNumber(uiData.dispEq));
        setUiValueToSdkIfNotNil(sdkData, 'dispRSqr', convertBoolToNumber(uiData.dispRSqr));

        ShapeConvert.convertDataUiToSdk(uiData, sdkData, {});
        // ShapeConvert 里会处理type字段， 所以这里的type放到后面
        sdkData.type = uiData.type;
        return sdkData;
    }

    type: TrendlineType;
    props: any;
    name?: string;
    dispEq?: boolean;   // 是否显示公式
    dispRSqr?: boolean; // 显示R平方值

    period?: number;    // 周期，移动平均的属性
    order?: number;     // 多项式阶数，多项式的属性
    forward?: number;   // 趋势预测 前推周期
    backward?: number;  // 趋势预测 后推周期
    seriesId?: string;   // 用于trendLine定位所属series
    idx?: number;        // 在trendlines的索引

    constructor(props, seriesId, idx) {
        const { type, period, order, forward, backward, name, dispEq, dispRSqr } = props;

        this.type = type;
        this.period = period;
        this.order = order;
        this.forward = forward;
        this.backward = backward;
        this.name = name;
        this.dispEq = !!dispEq;
        this.dispRSqr = !!dispRSqr;
        this.seriesId = seriesId;
        this.idx = idx;

        ShapeConvert.convertDataSdkToUi(props, this, undefined);
    }
}

// eslint-disable-next-line complexity
export function getAvailableTrendline(chartType: ChartType, grouping?: EGrouping) {
    switch (chartType) {
        case ChartType.BAR:
        case ChartType.BAR_3D:
        case ChartType.LINE:
        case ChartType.LINE_3D:
            return grouping !== EGrouping.STACKED && grouping !== EGrouping.PERCENT_STACKED;
        case ChartType.SCATTER:
        case ChartType.BUBBLE:
            return true;
        case ChartType.PIE:
        case ChartType.PIE_3D:
        case ChartType.DOUGHNUT:
        case ChartType.RADAR:
        case ChartType.AREA:
        case ChartType.AREA_3D:
            return false;
        default:
            return false;
    }
}
